// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-containers-___SelectedNode__button___VTFWb {
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  padding: 0.75em 1em;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
.src-styles-containers-___SelectedNode__button___VTFWb.src-styles-containers-___SelectedNode__success___VDKjv {
  background-color: #4ca92f;
  color: #ffffff;
}
.src-styles-containers-___SelectedNode__button___VTFWb.src-styles-containers-___SelectedNode__success___VDKjv:hover {
  background-color: #3a8124;
  color: #ffffff;
}
.src-styles-containers-___SelectedNode__button___VTFWb.src-styles-containers-___SelectedNode__alert___JIXiu {
  background-color: #ff401e;
  color: #ffffff;
}
.src-styles-containers-___SelectedNode__button___VTFWb.src-styles-containers-___SelectedNode__alert___JIXiu:hover {
  background-color: #ea2400;
  color: #ffffff;
}
.src-styles-containers-___SelectedNode__button___VTFWb:disabled,
.src-styles-containers-___SelectedNode__button___VTFWb:disabled:hover {
  background-color: rgba(150, 150, 150, 0.5);
}
.src-styles-containers-___SelectedNode__inputField___upkoP {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
.src-styles-containers-___SelectedNode__node___lFfh8 {
  padding: 2em;
  position: relative;
}
.src-styles-containers-___SelectedNode__node___lFfh8 {
  /* @import (less) '../../../node_modules/react-select/dist/react-select.min.css'; */
}
.src-styles-containers-___SelectedNode__name___fzhiG {
  margin-bottom: 0.5em;
}
.src-styles-containers-___SelectedNode__name___fzhiG input[type=text] {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
.src-styles-containers-___SelectedNode__id___axKrx {
  font-size: 1em;
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__target--wrapper___EvY0r {
  margin: 1em 0;
}
.src-styles-containers-___SelectedNode__target--wrapper___EvY0r .rc-collapse:not(:last-child) {
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__target--wrapper___EvY0r label {
  margin-right: 0.5em;
}
.src-styles-containers-___SelectedNode__target--wrapper___EvY0r label + input[type=text] {
  width: 100%;
  padding: 5px;
}
.src-styles-containers-___SelectedNode__target--title-button-group___hlIhe {
  visibility: visible;
  /* spaceholder*/
}
.src-styles-containers-___SelectedNode__target--button-container___Mb4L5 {
  display: flex;
  /* flex-wrap: wrap; */
  align-items: stretch;
  align-content: space-around;
  margin-top: 0em;
  margin-bottom: 4px;
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  float: right;
  height: 45px;
}
.src-styles-containers-___SelectedNode__target--button-group___PASPa .src-styles-containers-___SelectedNode__target--button-container___Mb4L5 > div,
.src-styles-containers-___SelectedNode__target--button-group___PASPa .src-styles-containers-___SelectedNode__target--button-container___Mb4L5 > button,
.src-styles-containers-___SelectedNode__target--button-group___PASPa .src-styles-containers-___SelectedNode__target--button-container___Mb4L5 a {
  max-width: 49%;
  min-width: 49%;
  margin-top: 3px;
}
.src-styles-containers-___SelectedNode__target--title-group___GLEt5 {
  float: left;
  margin-right: 0.5em;
}
.src-styles-containers-___SelectedNode__target--button-group___PASPa {
  float: right;
  max-width: 300px;
  min-width: 230px;
}
.src-styles-containers-___SelectedNode__enable-button___HjWcY {
  flex-grow: 1;
  font-size: 1em;
  text-align: center;
  border: none;
  color: #4ca92f;
  background: #ffffff;
  margin-top: 0.2em;
  outline: none;
}
.src-styles-containers-___SelectedNode__save-button___xB0fj {
  flex-grow: 1;
  font-size: 1em;
  text-align: center;
  border: none;
}
.src-styles-containers-___SelectedNode__target--link___BawMt {
  max-width: 300px;
  flex-grow: 1;
  font-size: 1em;
  text-align: center;
  margin-left: 0.5em;
  margin-top: 0.2em;
}
.src-styles-containers-___SelectedNode__target--link___BawMt i {
  vertical-align: middle;
}
.src-styles-containers-___SelectedNode__delete-button___D9ha8 {
  flex-grow: 1;
  font-size: 1em;
  text-align: center;
  border: none;
}
.src-styles-containers-___SelectedNode__delete-feedback-button___UiEI9 {
  flex-grow: 1;
  font-size: 1em;
  text-align: center;
  border: none;
  padding: 0.25em 1em !important;
}
.src-styles-containers-___SelectedNode__hidden___uh7F0 {
  display: none;
}
.src-styles-containers-___SelectedNode__parent--selector___qneZK .src-styles-containers-___SelectedNode__target--selector___tExBo {
  display: block;
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__jump--button___tfnzI {
  width: 10%;
  flex-grow: 1;
  font-size: 1em;
  text-align: center;
  border: none;
  margin-top: 0.2em;
  margin-right: 1%;
}
.src-styles-containers-___SelectedNode__target--selector___tExBo {
  width: 85%;
  margin-top: 6px;
}
.src-styles-containers-___SelectedNode__question--selector___Vl6LK {
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__theme--selector___YqqmR {
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg {
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg legend + div {
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg .Select-control {
  height: calc(5em + (16 / 16px));
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg .Select img {
  max-height: 5em;
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg .dropzone {
  display: inline-block;
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg .image--preview {
  max-width: 480px;
  max-height: 460px;
}
.src-styles-containers-___SelectedNode__picture--selector___uxeAg .image--preview img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
}
.src-styles-containers-___SelectedNode__other-superuser-settings___pFv0x > div {
  padding-top: 2px;
  padding-bottom: 2px;
}
.src-styles-containers-___SelectedNode__qrcode--selector___XwdYN {
  margin-bottom: 1em;
}
fieldset + fieldset {
  margin-top: 1em;
}
@media (max-width: 1249px) {
  .src-styles-containers-___SelectedNode__target--button-group___PASPa {
    float: left;
    width: 100%;
  }
  .src-styles-containers-___SelectedNode__target--title-break___hch1W {
    clear: both;
  }
}
@media (max-width: 800px) {
  .src-styles-containers-___SelectedNode__target--button-group___PASPa {
    float: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixins.less","webpack://./src/styles/containers/SelectedNode.less"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,oDAAA;ACDF;ADGE;EACE,yBAAA;EACA,cAAA;ACDJ;ADGI;EACE,yBAAA;EACA,cAAA;ACDN;ADKE;EACE,yBAAA;EACA,cAAA;ACHJ;ADKI;EACE,yBAAA;EACA,cAAA;ACHN;ADOE;;EACE,0CAAA;ACJJ;ADQA;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACNF;AAlCA;EACE,YAAA;EACA,kBAAA;AAoCF;AAtCA;EAwCE,mFAAmF;AACrF;AAhCA;EACE,oBAAA;AAkCF;AAnCA;ED0BE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACYF;AAnCA;EACE,cAAA;EACA,kBAAA;AAqCF;AAlCA;EACE,aAAA;AAoCF;AArCA;EAKM,kBAAA;AAmCN;AAxCA;EAUI,mBAAA;AAiCJ;AA3CA;EAcI,WAAA;EACA,YAAA;AAgCJ;AA5BA;EACE,mBAAA;EA8BA,eAAe;AACjB;AA5BA;EACE,aAAA;EA8BA,qBAAqB;EA5BrB,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA8BF;AA3BA;;;EAEI,cAAA;EACA,cAAA;EACA,eAAA;AA8BJ;AA1BA;EACE,WAAA;EACA,mBAAA;AA4BF;AAzBA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AA2BF;AAxBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;AA0BF;AAvBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAyBF;AAtBA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAwBF;AA9BA;EAQI,sBAAA;AAyBJ;AArBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;AAuBF;AApBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;AAsBF;AAnBA;EACE,aAAA;AAqBF;AAlBA;EACE,cAAA;EACA,kBAAA;AAoBF;AAjBA;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAmBF;AAhBA;EACE,UAAA;EACA,eAAA;AAkBF;AAfA;EACE,kBAAA;AAiBF;AAdA;EACE,kBAAA;AAgBF;AAbA;EACE,kBAAA;AAeF;AAhBA;EAII,kBAAA;AAeJ;AAnBA;EASM,+BAAA;AAaN;AAtBA;EAaM,eAAA;AAYN;AAzBA;EAiBM,qBAAA;AAWN;AA5BA;EAqBM,gBAAA;EACA,iBAAA;AAUN;AAhCA;EAwBQ,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAWR;AALC;EACG,gBAAA;EACA,mBAAA;AAOJ;AAHA;EACE,kBAAA;AAKF;AAEA;EACE,eAAA;AAAF;AAGA;EACE;IACE,WAAA;IACA,WAAA;EADF;EAGA;IACE,WAAA;EADF;AACF;AAIA;EACE;IACE,WAAA;EAFF;AACF","sourcesContent":["@import './variables.less';\n\n.button {\n  background-color: transparent;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  color: @color-main-white;\n  padding: 0.75em 1em;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  transition: @transition;\n  \n  &.success {\n    background-color: @color-main-green;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-green, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &.alert {\n    background-color: @color-main-red;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-red, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &:disabled, &:disabled:hover {\n    background-color: @color-main-gray;\n  }\n}\n\n.inputField {\n  font-size: 1.5em;\n  border: 1px solid @color-main-gray;\n  border-radius: 3px;\n  padding: 0.2em;\n  min-width: 300px;\n  width: 100%;\n}\n","@import '../variables.less';\n@import '../mixins.less';\n\n.node {\n  padding: 2em;\n  position: relative;\n\n  :global {\n    /* @import (less) '../../../node_modules/react-select/dist/react-select.min.css'; */\n  }\n}\n\n.name {\n  margin-bottom: 0.5em;\n\n  input[type=text] {\n    .inputField();\n  }\n}\n\n.id {\n  font-size: 1em;\n  margin-bottom: 1em;\n}\n\n.target--wrapper {\n  margin: 1em 0;\n\n  :global {\n    .rc-collapse:not(:last-child) {\n      margin-bottom: 1em;\n    }\n  }\n\n  label {\n    margin-right: 0.5em;\n  }\n\n  label + input[type=text] {\n    width: 100%;\n    padding: 5px;\n  }\n}\n\n.target--title-button-group {\n  visibility: visible; /* spaceholder*/\n}\n\n.target--button-container {\n  display: flex;\n  /* flex-wrap: wrap; */\n  align-items: stretch;\n  align-content: space-around;\n  margin-top: 0em;\n  margin-bottom: 4px;;\n  margin-left: 0;\n  margin-right: 0;\n  width: 100%;\n  float: right;\n  height: 45px;\n}\n\n.target--button-group .target--button-container {\n  > div, > button, a {\n    max-width: 49%;\n    min-width: 49%;\n    margin-top: 3px;\n  }\n}\n\n.target--title-group {\n  float: left;\n  margin-right: 0.5em;\n}\n\n.target--button-group {\n  float: right;\n  max-width: 300px;\n  min-width: 230px;\n}\n\n.enable-button {\n  flex-grow: 1;\n  font-size: 1em;\n  text-align: center;\n  border: none;\n  color: @color-main-green;\n  background: @color-main-white;\n  margin-top: 0.2em;\n  outline: none;\n}\n\n.save-button {\n  flex-grow: 1;\n  font-size: 1em;\n  text-align: center;\n  border: none;\n}\n\n.target--link {\n  max-width: 300px;\n  flex-grow: 1;\n  font-size: 1em;\n  text-align: center;\n  margin-left: 0.5em;\n  margin-top: 0.2em;\n  i {\n    vertical-align: middle;\n  }\n}\n\n.delete-button {\n  flex-grow: 1;\n  font-size: 1em;\n  text-align: center;\n  border: none;\n}\n\n.delete-feedback-button {\n  flex-grow: 1;\n  font-size: 1em;\n  text-align: center;\n  border: none;\n  padding: 0.25em 1em !important;\n}\n\n.hidden {\n  display: none;\n}\n\n.parent--selector .target--selector {\n  display: block;\n  margin-bottom: 1em;\n}\n\n.jump--button {\n  width: 10%;\n  flex-grow: 1;\n  font-size: 1em;\n  text-align: center;\n  border: none;\n  margin-top: 0.2em;\n  margin-right: 1%;\n}\n\n.target--selector {\n  width: 85%;\n  margin-top: 6px;\n}\n\n.question--selector {\n  margin-bottom: 1em;\n}\n\n.theme--selector {\n  margin-bottom: 1em;\n}\n\n.picture--selector {\n  margin-bottom: 1em;\n\n  legend + div {\n    margin-bottom: 1em;\n  }\n\n  :global {\n    .Select-control {\n      height: calc(5em + (16 / @em));\n    }\n\n    .Select img {\n      max-height: 5em;\n    }\n\n    .dropzone {\n      display: inline-block;\n    }\n\n    .image--preview {\n      max-width: 480px;\n      max-height: 460px;\n      img {\n        max-width: 100%;\n        max-height: 100%;\n        display: block;\n        margin-top: 1em;\n        margin-bottom: 1em;\n      }\n    }\n  }\n}\n\n .other-superuser-settings > div {\n    padding-top: 2px;\n    padding-bottom: 2px;\n }\n\n\n.qrcode--selector {\n  margin-bottom: 1em;\n}\n\n.target--title-break {\n\n}\n\nfieldset + fieldset {\n  margin-top: 1em;\n}\n\n@media (max-width: 1249px) {\n  .target--button-group {\n    float: left;\n    width: 100%;\n  }\n  .target--title-break {\n    clear: both;\n  }\n}\n\n@media (max-width: 800px) {\n  .target--button-group {\n    float: left;\n  }\n}"],"sourceRoot":""}]);
// Exports
export var button = `src-styles-containers-___SelectedNode__button___VTFWb`;
export var success = `src-styles-containers-___SelectedNode__success___VDKjv`;
export var alert = `src-styles-containers-___SelectedNode__alert___JIXiu`;
export var inputField = `src-styles-containers-___SelectedNode__inputField___upkoP`;
export var node = `src-styles-containers-___SelectedNode__node___lFfh8`;
export var name = `src-styles-containers-___SelectedNode__name___fzhiG`;
export var id = `src-styles-containers-___SelectedNode__id___axKrx`;
var _1 = `src-styles-containers-___SelectedNode__target--wrapper___EvY0r`;
export { _1 as "target--wrapper" };
var _2 = `src-styles-containers-___SelectedNode__target--title-button-group___hlIhe`;
export { _2 as "target--title-button-group" };
var _3 = `src-styles-containers-___SelectedNode__target--button-container___Mb4L5`;
export { _3 as "target--button-container" };
var _4 = `src-styles-containers-___SelectedNode__target--button-group___PASPa`;
export { _4 as "target--button-group" };
var _5 = `src-styles-containers-___SelectedNode__target--title-group___GLEt5`;
export { _5 as "target--title-group" };
var _6 = `src-styles-containers-___SelectedNode__enable-button___HjWcY`;
export { _6 as "enable-button" };
var _7 = `src-styles-containers-___SelectedNode__save-button___xB0fj`;
export { _7 as "save-button" };
var _8 = `src-styles-containers-___SelectedNode__target--link___BawMt`;
export { _8 as "target--link" };
var _9 = `src-styles-containers-___SelectedNode__delete-button___D9ha8`;
export { _9 as "delete-button" };
var _a = `src-styles-containers-___SelectedNode__delete-feedback-button___UiEI9`;
export { _a as "delete-feedback-button" };
export var hidden = `src-styles-containers-___SelectedNode__hidden___uh7F0`;
var _b = `src-styles-containers-___SelectedNode__parent--selector___qneZK`;
export { _b as "parent--selector" };
var _c = `src-styles-containers-___SelectedNode__target--selector___tExBo`;
export { _c as "target--selector" };
var _d = `src-styles-containers-___SelectedNode__jump--button___tfnzI`;
export { _d as "jump--button" };
var _e = `src-styles-containers-___SelectedNode__question--selector___Vl6LK`;
export { _e as "question--selector" };
var _f = `src-styles-containers-___SelectedNode__theme--selector___YqqmR`;
export { _f as "theme--selector" };
var _10 = `src-styles-containers-___SelectedNode__picture--selector___uxeAg`;
export { _10 as "picture--selector" };
var _11 = `src-styles-containers-___SelectedNode__other-superuser-settings___pFv0x`;
export { _11 as "other-superuser-settings" };
var _12 = `src-styles-containers-___SelectedNode__qrcode--selector___XwdYN`;
export { _12 as "qrcode--selector" };
var _13 = `src-styles-containers-___SelectedNode__target--title-break___hch1W`;
export { _13 as "target--title-break" };
export default ___CSS_LOADER_EXPORT___;
